module.exports = __webpack_public_path__ + "static/media/fender.fe19188a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CubeGrid/assets/fender.jpg
// module id = 472
// module chunks = 0